// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breathe {
    transform-origin: bottom left;
    animation: breathe 4s ease-in-out infinite;
  }
  
  .card-enter {
    animation: cardEnter 2s ease-in-out forwards;
    margin-top: 5%;
  }
  
  .animate-element {
    animation: elementEnter 0.3s ease-in-out forwards;
  }
  
  @keyframes elementEnter {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes cardEnter {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  @keyframes breathe {
    0% {
      transform: rotate(-0.5deg);
    }
    50% {
      transform: rotate(0.5deg);
      opacity: 1;
    }
    100% {
      transform: rotate(-0.5deg);
      opacity: 1;
    }
  }
  
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,0CAA0C;EAC5C;;EAEA;IACE,4CAA4C;IAC5C,cAAc;EAChB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,yBAAyB;MACzB,UAAU;IACZ;IACA;MACE,0BAA0B;MAC1B,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf","sourcesContent":[".breathe {\r\n    transform-origin: bottom left;\r\n    animation: breathe 4s ease-in-out infinite;\r\n  }\r\n  \r\n  .card-enter {\r\n    animation: cardEnter 2s ease-in-out forwards;\r\n    margin-top: 5%;\r\n  }\r\n  \r\n  .animate-element {\r\n    animation: elementEnter 0.3s ease-in-out forwards;\r\n  }\r\n  \r\n  @keyframes elementEnter {\r\n    0% {\r\n      opacity: 0;\r\n      transform: translateY(-100%);\r\n    }\r\n    100% {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n  \r\n  @keyframes cardEnter {\r\n    0% {\r\n      opacity: 0;\r\n    }\r\n    100% {\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  @keyframes breathe {\r\n    0% {\r\n      transform: rotate(-0.5deg);\r\n    }\r\n    50% {\r\n      transform: rotate(0.5deg);\r\n      opacity: 1;\r\n    }\r\n    100% {\r\n      transform: rotate(-0.5deg);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  .loading-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 300px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
